import "i18next";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Paper, Box, Tabs, Tab, Badge, Typography } from "@mui/material";
import SearchRequests from "./SearchRequests";
import SearchTrainees from "./SearchTrainees";
import SearchRequisitions from "./SearchRequisitions";
import SearchRosters from "./SearchRosters";
import RosterManagement from "./RosterManagement";
import { useNavigate } from "react-router-dom";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </Box>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
export default function TabbedPanel({ currentIndex }) {
  const { t } = useTranslation(["TabbedPanel"], {
    useSuspense: false,
  });
  const [value, setValue] = useState(currentIndex || 0);
  const [requestLength, setRequestLength] = useState(0);
  const [traineeLength, setTraineeLength] = useState(0);
  const [rosterLength, setRosterLength] = useState(0);
  const [rosterCount, setRosterCount] = useState(0);
  const [rosterManagementLength, setRosterManagementLength] = useState(0);
  const navigate = useNavigate();
  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 0) {
      navigate("/home/searchrequests");
    } else if (newValue === 1) {
      navigate("/home/searchtrainees");
    } else if (newValue === 2) {
      navigate("/home/searchrequisitions");
    } else if (newValue === 3) {
      navigate("/home/searchrosters");
    } else if (newValue === 4) {
      navigate("/home/rosterbulkedit");
    }
  };
  return (
    <Paper
      sx={{
        display: "flex",
        flexGrow: 1,
        flexDirection: "column",
        boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.35)",
        p: 1,
        height: "calc(100vh - 95px)",
      }}
    >
      <Box>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label={t("aria-label.simple_tabs_example")}
          TabIndicatorProps={{
            sx: {
              backgroundColor: "#3299FF",
              height: "5px",
            },
          }}
          sx={{
            "& .MuiTab-root": {
              fontSize: "14px",
              fontWeight: "bold",
              color: "#3F5765",
              letterSpacing: "0.10em",
              textTransform: "none",
              minWidth: "auto",
              "&.Mui-selected": {
                color: "#3299FF",
              },
              "&:hover": {
                color: "#3299FF",
              },
            },
          }}
        >
          <Tab
            label={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: requestLength > 0 ? 2.5 : 0,
                }}
              >
                {t("tab.class_request")}
                {requestLength > 0 && (
                  <Badge
                    badgeContent={requestLength}
                    max={999}
                    sx={{
                      "& .MuiBadge-badge": {
                        backgroundColor: "#3299FF",
                        color: "white",
                        marginLeft: "8px",
                      },
                    }}
                  />
                )}
              </Box>
            }
            {...a11yProps(1)}
          />
          <Tab
            label={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: traineeLength > 0 ? 2.5 : 0,
                }}
              >
                {t("tab.class_trainee")}
                {traineeLength > 0 && (
                  <Badge
                    badgeContent={traineeLength}
                    max={999}
                    sx={{
                      "& .MuiBadge-badge": {
                        backgroundColor: "#3299FF",
                        color: "white",
                        marginLeft: "8px",
                      },
                    }}
                  />
                )}
              </Box>
            }
            {...a11yProps(1)}
          />
          <Tab
            label={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: rosterLength > 0 ? 2.5 : 0,
                }}
              >
                {t("tab.requisition")}
                {rosterLength > 0 && (
                  <Badge
                    badgeContent={rosterLength}
                    max={999}
                    sx={{
                      "& .MuiBadge-badge": {
                        backgroundColor: "#3299FF",
                        color: "white",
                        marginLeft: "8px",
                      },
                    }}
                  />
                )}
              </Box>
            }
            {...a11yProps(2)}
          />
          <Tab
            label={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: rosterCount > 0 ? 2.5 : 0,
                }}
              >
                {t("tab.class_roster")}
                {rosterCount > 0 && (
                  <Badge
                    badgeContent={rosterCount}
                    max={999}
                    sx={{
                      "& .MuiBadge-badge": {
                        backgroundColor: "#3299FF",
                        color: "white",
                        marginLeft: "8px",
                      },
                    }}
                  />
                )}
              </Box>
            }
            {...a11yProps(3)}
          />
          <Tab
            label={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: rosterManagementLength > 0 ? 2.5 : 0,
                }}
              >
                {t("tab.roster_management", "Roster Management")}
                {rosterManagementLength > 0 && (
                  <Badge
                    badgeContent={rosterManagementLength}
                    max={999}
                    sx={{
                      "& .MuiBadge-badge": {
                        backgroundColor: "#3299FF",
                        color: "white",
                        marginLeft: "8px",
                      },
                    }}
                  />
                )}
              </Box>
            }
            {...a11yProps(4)}
          />
        </Tabs>

        <TabPanel value={value} index={0}>
          <SearchRequests setRequestLength={setRequestLength} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <SearchTrainees setTraineeLength={setTraineeLength} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <SearchRequisitions setRosterLength={setRosterLength} />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <SearchRosters setRosterCount={setRosterCount} />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <RosterManagement setRosterManagementLength={setRosterManagementLength} />
        </TabPanel>
      </Box>
    </Paper>
  );
}
TabbedPanel.propTypes = {
  currentIndex: PropTypes.number,
};
